import { Formik, Form } from "formik";
import React, { FC, useEffect, useState } from "react";
import { useLocale } from "../../../contexts/localeContext";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import WizardSideBarStep from "../../../models/WizardSideBarStep";
import { updateButtonData } from "../../../services/biometricPresetService";
import { showError } from "../../../services/utilities/ServiceError";
import Wizard from "../../wizard/wizard";
import ButtonConfigEditStep from "./ButtonConfigEditStep";
import ButtonSummary from "./Summary";
import { toast } from "react-toastify";

interface ButtonConfigWizardProps {
    rowData: any,
    onClose: () => void,
    setBusy: (busy: boolean) => void
}

const ButtonConfigWizard: FC<ButtonConfigWizardProps> = ({ rowData, onClose, setBusy }) => {
    const { translate } = useLocale();
    const [step, setStep] = useState<number>(0);

    const onLocalNext = (event) => {
        setSideBarStepDescription(0, event.buttonText)
        setStep(step + 1);
    }

    const onLocalBack = (event?: any) => {
        setStep(step - 1);
    }

    const content = [
        <ButtonConfigEditStep
            onBack={onLocalBack}
            onNext={onLocalNext}
        />,
        <ButtonSummary onBack={onLocalBack} />
    ]

    const [steps, setSteps] = useState<WizardSideBarStep[]>([
        {
            title: translate.byKey(TranslationKeys.description),
            description: rowData.nameOriginal,
            substeps: []
        },
        {
            title: translate.byKey(TranslationKeys.summary),
            description: translate.byKey(TranslationKeys.pending),
            substeps: []
        },
    ]);

    const setSideBarStepDescription = (index, newDescription) => {
        const newSideBarSteps = steps.map((step, stepIndex) => {
            return { ...step, description: stepIndex === index ? newDescription : step.description };
        });
        setSteps(newSideBarSteps);
    };

    const onSave = async (values) => {
        setBusy(true)
        try {
            await updateButtonData(values);
            toast.success(translate.byKey(TranslationKeys.success));
        } catch (error) {
            showError(error, toast.warn);
        } finally {
            await setBusy(false)
            onClose()
        }

    }

    return (<Formik
        enableReinitialize={true}
        initialValues={{
            id: rowData.id,
            buttonText: rowData.nameOriginal,
            type: rowData.type,
            typeId: rowData.typeId,
            profileId: rowData.profileId
        }}
        onSubmit={onSave}>
        <Form>
            <Wizard name={`Edit Button: ${rowData.type}`}
                step={step}
                onClose={onClose}
                sidebarSteps={steps}>
                {content}
            </Wizard>
        </Form>
    </Formik>);
}

export default ButtonConfigWizard;